import { createContext, useContext } from "react";

/**
 * Names of filter form fields frozen by the active saved table view's lock.
 * Provided by `CrmFilterActionButtons` around the filter panel; the shared
 * form fields (`MyTextField`, `MyAutocompleteField`, `MyAutoCompleteFieldQuery`)
 * consult it by their `name` and render disabled when frozen — their values
 * stay visible and are preserved by Apply/Clear all. The default (empty set)
 * means no field is ever locked outside a locked saved view.
 */
export const LockedFilterFieldsContext = createContext<ReadonlySet<string>>(
  new Set()
);

export const useIsFilterFieldLocked = (name?: string): boolean => {
  const lockedKeys = useContext(LockedFilterFieldsContext);
  return !!name && lockedKeys.has(name);
};
